<script lang="ts">
  import Prose from '../lib/components/Prose.svelte';
</script>

<section id="conclusion" class="section">
  <Prose>
    <header class="header">
      <div class="eyebrow">Conclusion</div>
      <h2>Count the chain</h2>
    </header>

    <p>
      Before spending money on an agent, count the steps it has to get right.
    </p>

    <p>
      P(success) = p<sub>step</sub><sup>N</sup>. If the task's atomic operations
      are not dense in training as reliable facts, p<sub>step</sub> will be low
      no matter how carefully the prompt is written. If the chain is long, even
      strong per-step accuracy decays. Below roughly 70%, the task needs
      structural help: fewer steps, a tool that collapses the unreliable
      operation, or a different model.
    </p>

    <p>
      Prompts and scaffolds can reshape the chain by lowering N or steering the
      task toward operations the weights handle reliably. That can move the
      number. What they cannot do is make the model reliably recall an operation
      it does not know. Verification from the same distribution tends to confirm
      the same mistakes; independent checks are what catch them.
    </p>
  </Prose>
</section>

<style>
  .section {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: var(--space-4xl);
    width: 100%;
    min-width: 0;
  }
  .header {
    margin-bottom: var(--space-lg);
  }
  .eyebrow {
    font-family: var(--font-sans);
    font-size: var(--text-xs);
    font-weight: var(--weight-medium);
    color: var(--ink-muted);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    margin-bottom: var(--space-sm);
  }
</style>
